export enum ChatFiltersPresetTableTab {
  global = 'Global Filters',
  personal = 'Personal Filters',
  all = 'All Filters',
}
